/**
 * Share of the history months with an issue at or below which the XYZ class counts as resting on
 * sparse history. The design flags 18 of 24 months (75 %) as below recommended; the API has no
 * flag for it yet, so the frontend applies this threshold until the backend exposes one.
 */
export const SPARSE_HISTORY_ACTIVE_MONTHS_RATIO = 0.75;
